import { GeckoSiteGrouping } from 'types'

/**
 * Gets all grouping IDs in the hierarchy starting from a selected grouping ID.
 * Returns an array containing the selected grouping and all its parent groupings.
 * Prevents infinite loops by tracking visited nodes.
 *
 * @param selectedGroupingId - The ID of the grouping to start from
 * @param groupings - Array of all available groupings
 * @returns Array of grouping IDs from selected grouping up to root parent
 *
 * @example
 * // Given groupings: A -> B -> C (where C is child of B, B is child of A)
 * // getGroupingHierarchy('C', groupings) returns ['C', 'B', 'A']
 */
export const getGroupingHierarchy = (
  selectedGroupingId: string,
  groupings: GeckoSiteGrouping[]
): string[] => {
  const hierarchyIds: string[] = []
  const visitedIds = new Set<string>()
  let currentGroupingId: string | undefined = selectedGroupingId

  while (
    currentGroupingId !== undefined &&
    !visitedIds.has(currentGroupingId)
  ) {
    hierarchyIds.push(currentGroupingId)
    visitedIds.add(currentGroupingId)

    const currentGrouping = groupings.find((g) => g.id === currentGroupingId)
    currentGroupingId = currentGrouping?.parent
  }

  return hierarchyIds
}
